export default {
	items: [],
	next_page_index: 1,
}